import axios from 'axios';
import { User } from '../types/User';
import { baseUrl, HttpMethods } from './base';
import { QueryParamsInterface } from '../types/Shared';

interface IGetUsersService {
  params?: QueryParamsInterface;
}

export interface IGetUsersServiceParams {
  name: string;
  email: string;
  title_id: string;
  active: string;
}

interface IGetUsersServiceRes {
  data: User[];
  meta: { total: number };
}

export async function getUsers({
  params,
}: IGetUsersService): Promise<IGetUsersServiceRes> {
  const resp = await axios.request<IGetUsersServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/users/list`,
    params,
  });
  return resp.data;
}

export interface IPostUserInviteServicePayload {
  name: string;
  email: string;
  titleId: number;
}

export async function sendInvite(formData: IPostUserInviteServicePayload) {
  const resp = await axios.post('/sherpa/v0/api/users/invite', formData);
  return resp.data;
}

export async function postForgotPassword(data: { email: string }) {
  const resp = await axios({
    method: HttpMethods.POST,
    url: `/sherpa/v0/auth/users/forgot_password`,
    data,
  });
  return resp;
}

export async function resetPassword(data: {
  password: string;
  passwordConfirmation: string;
  token: string;
}) {
  const resp = await axios.patch('/sherpa/v0/auth/users/reset_password', data);
  return resp.data;
}

export async function userOnboard(data: {
  tempPassword: string;
  password: string;
  passwordConfirmation: string;
  token: string;
}) {
  const response = await axios.post('sherpa/v0/api/users/invite/confirm', data);
  return response;
}

export async function postReInviteUser(userId: number) {
  const response = await axios.post(`/sherpa/v0/api/users/${userId}/reinvite`);
  return response.data;
}

export async function deleteUser(userId: number) {
  const response = await axios.delete(`/sherpa/v0/api/users/${userId}`);
  return response;
}

export async function getUser(userId: number) {
  const response = await axios.get(`/sherpa/v0/api/users/${userId}`);
  return response.data;
}

export async function updateUser(id: number, data: object) {
  const response = await axios.patch(`/sherpa/v0/api/users/${id}`, data);
  return response;
}
